import { z } from 'zod';

import { transformKeysToCamelCase } from 'utils/formatters/transform-snake-to-camel';

const InvoiceSchema = z.object({
  name: z.string(),
  manufacturer: z.string(),
  model: z.string(),
  period: z.string(),
  price_usd: z.number(),
  price_btc: z.number(),
  price_ltc: z.string(),
  price_ust: z.string(),
  price_eth: z.string(),
  unit_price: z.string(),
  hashrate: z.number(),
  algorithm: z.string(),
  start_at: z.string(),
  start_delay: z.number(),
  term: z.number(),
  management_fee: z.string(),
  electricity_fee: z.number(),
  discount: z.number(),
  tax: z.number(),
  pool_type: z.string(),
  is_trial: z.boolean(),
});

const invoices = z.record(z.string(), InvoiceSchema);

export const InvoicesResponseSchema = z
  .object({
    data: z.object({
      id: z.number(),
      user_id: z.number(),
      bill_id: z.number(),
      created_at: z.string(),
      invoices: invoices,
      cost_price_usd: z.number(),
      costs_usd: z.number(),
      cost_price_btc: z.number(),
      costs_btc: z.number(),
      price_ltc: z.number(),
      price_ust: z.number(),
      price_eth: z.number(),
      electricity_fee: z.number(),
      discount: z.number(),
      start_at: z.string(),
    }),
  })
  .transform(transformKeysToCamelCase);

export type TInvoicesResponse = z.infer<typeof InvoicesResponseSchema>;
export type TInvoicesData = TInvoicesResponse['data'];
export type TInvoices = z.infer<typeof invoices>;
